import { theme } from '~/theme';

export const useSxStyles = () => {
  const highlightColor = '#05A4D8';
  const valueFontSize = '13px';
  return {
    updateHeading: {
      padding: theme.spacing(0.5, 1),
    },
    updateGroup: {
      margin: theme.spacing(0.5, 1),
    },
    valueLabel: {
      fontWeight: 'bold',
      fontSize: '14px',
    },
    valueOld: {
      fontSize: valueFontSize,
    },
    valueArrow: {
      color: highlightColor,
    },
    valueNew: {
      color: highlightColor,
      fontSize: valueFontSize,
    },
  };
};
